import { LocalTime } from '#.shared/dates/types.ts'
import z from 'zod'

declare const ShiftPresetIDSymbol: unique symbol
export type ShiftPresetID = string & { [ShiftPresetIDSymbol]: never }

export const ShiftPresetSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    color_hex: z.string(),
    start_time: z.string(),
    end_time: z.string(),
  })
  .transform((obj) => {
    return {
      id: obj.id as ShiftPresetID,
      name: obj.name,
      colorHex: obj.color_hex,
      startTime: LocalTime.parse(obj.start_time),
      endTime: LocalTime.parse(obj.end_time),
    }
  })

export type ShiftPreset = z.infer<typeof ShiftPresetSchema>
